export const environment = {
    production: false,
    company: 'CADIELSA GRUPO',
    apiURL: 'https://cadielsa.canaldelinformante.com/backend',
    address: 'Polígono Industrial La Mata, C. de la Hierbabuena, 88, Nave 7 y 8, 28440 Guadarrama, Madrid'
};
